import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../../../lib/moment.js'
import find from 'lodash/find'
import get from 'lodash/get'
import { Input } from 'reactstrap'
import { leaveColor } from '../../helpers/color'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'

export const DataInput = (props) => {
  const { projectID, taskID, task, project, holidays,
    leaveRequests, compensateRequests, invalidList, weekdates } = props
  const { isEdit } = props
  const { editHour } = props

  return (
    <Column>
      { weekdates.map((time) => {
        let day = ''
        const id = shortid()
        const invalid = find(invalidList, { timeID: moment(time).format('YYYY-MM-DD') })
        const isWeekend = moment(time).day() === 0 || moment(time).day() === 6
        const isHoliday = find(holidays, { date: (moment(time).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, { date: time })
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, { date: time }, project)
        const leaveCondition = !isWeekend
          && !isHoliday
          && ((hasLeave.length === 1 && hasLeave[0].leave_time !== 'FULLDAY') || !hasLeave)
        const compensateCondition = (isWeekend && hasCompensate) || (isHoliday && hasCompensate)
        const show = leaveCondition || compensateCondition

        const date = find(get(task, 'times', []), (task2) => {
          const d1 = moment(task2.date).format('YYYY-MM-DD')
          const d2 = moment(time).format('YYYY-MM-DD')
          if (d1 === d2) return moment(date).format('YYYY-MM-DD')
          return null
        })

        
        // eslint-disable-next-line no-unused-vars
        let dataType
        
        // eslint-disable-next-line no-unused-vars
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.length > 1 ? CONSTANTS.FULLDAY : hasLeave[0].leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }
        if (!date) day = CONSTANTS.WEEKEND

        return (
          <Cell
            day={ day }
            canClick={ (isHoliday || hasLeave || hasCompensate) && !show }
          >{ show && date &&
            <InputField
              id={ id }
              type='number'
              autoComplete="off"
              step='0.5'
              value={ date ? date.hours : '' }
              invalid={ invalid }
              onFocus={ () => document.getElementById(id).select() }
              onChange={ (e) => editHour(e, taskID, parseInt(moment(date.date).format('DD'), 10) - 1, projectID, false) }
              onBlur={ (e) => editHour(e, taskID, parseInt(moment(date.date).format('DD'), 10) - 1, projectID, true) }
              disabled={ !isEdit }
            />
            }
          </Cell>
        )
      })}

    </Column>
  )
}

export const EmptyInput = (props) => {
  const { holidays, project, leaveRequests, compensateRequests, task } = props
  const { handleClickCell } = props

  return (
    <Column>
      <Total />
      {get(task, 'times', []).map(time => {
        let day = ''
        const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        const isHoliday = find(holidays, { date: (moment(time.date).format('YYYY-MM-DD')) })
        const hasLeave = timesheetHelper.checkHasLeaveRequest(leaveRequests, time)
        const hasCompensate = timesheetHelper.checkHasCompensateRequest(
          compensateRequests, time, project)

        let dataType
        let data

        if (isWeekend) day = CONSTANTS.WEEKEND
        else if (isHoliday) {
          day = CONSTANTS.HOLIDAY
          dataType = day
          data = isHoliday
        } if (hasLeave) {
          day = hasLeave.leave_time
          dataType = day
          data = hasLeave
        } else if (hasCompensate) {
          day = CONSTANTS.COMPENSATE
          dataType = day
          data = hasCompensate
        }

        return (
          <Cell
            key={ shortid() }
            day={ day }
            canClick={ isHoliday || hasLeave || hasCompensate }
            onClick={
              (isHoliday || hasLeave || hasCompensate) ?
                () => handleClickCell(dataType, data) : () => {}
            }
          >
            <Date />
          </Cell>
        )
      })}
    </Column>
  )
}

DataInput.propTypes = {
  projectID: PropTypes.string,
  editHour: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  task: PropTypes.object,
  taskID: PropTypes.number,
  holidays: PropTypes.array,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  invalidList: PropTypes.array,
  project: PropTypes.object,
  weekdates: PropTypes.array,
}
DataInput.defaultProps = {
  projectID: '',
  taskID: 0,
  isEdit: false,
  task: {},
  project: {},
  holidays: [],
  leaveRequests: [],
  compensateRequests: [],
  invalidList: [],
  weekdates: [],
}
EmptyInput.propTypes = {
  holidays: PropTypes.array,
  task: PropTypes.object,
  leaveRequests: PropTypes.array,
  compensateRequests: PropTypes.array,
  project: PropTypes.object,
  handleClickCell: PropTypes.func.isRequired,
}
EmptyInput.defaultProps = {
  holidays: [],
  task: {},
  leaveRequests: [],
  compensateRequests: [],
  project: {},
}

const InputField = styled(Input)`
  width: 70%;
  background-image: none !important;
  font-family: Gotham;
  font-size: 12px;
  padding: 0px !important;
  margin-bottom: 15%;
  margin-top: 15%;
  text-align: center;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const Column = styled.div`
  height: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
`
const Cell = styled.div`
  font-family: 'Gotham' !important;
  font-size: 10px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: ${props => { return props.canClick ? 'pointer' : 'default' }};
  @media (max-width: 575.98px) {
  border: solid #d2d2d2d2;
  border-width: 0.5px 0.5px 1px 0.5px;
  }
  @media (max-width: 767.98px) {
    border: solid #d2d2d2d2;
    border-width: 0.5px 0.5px 1px 0.5px;
  }
  background-color: ${(props) => { return leaveColor(props.day) }};
`
const Total = styled.span`
  width: 40px;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Date = styled.div`
  font-family: 'Gotham-Bold' !important;
  color: ${(props) => {
    if (props.isToday) return '#ad191f'
    return 'black'
  }};
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/input-col-mobile.js